export default __webpack_public_path__ + "static/media/tinydogz.3a8bbad6.png";